import { Form } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = Omit<ComponentPropsWithoutRef<typeof Form>, 'layout'>

/**
 * Antd の Form を 検索Form用にラップしたコンポーネント
 * - layout を vertical に固定
 * - 余白などのスタイルを変更
 */
export const SearchForm: FC<Props> = ({ className, children, ...props }) => {
  return (
    <Form
      {...props}
      className={clsx(['flex flex-col gap-2', className])}
      layout="vertical"
    >
      {children}
    </Form>
  )
}
